<template>
  <div>
      <gmap-map
        ref="map"
        :center="desiredCenter"
        :options="gmapOptions"
        :zoom="desiredZoom"
        class="gmap b122-gmap mt-2"
        @center_changed="onCenterChanged"
        @zoom_changed="onZoomChanged"
        @bounds_changed="onBoundsChanged"
        @dragend="onMapDrag"
      >
        <!-- region theft markers-->
        <GmapCluster
          :zoomOnClick="true"
          :maxZoom="16"
          :styles="clusterStyles"
          :calculator="clusterCalculator">
          <template v-for="(m, index) in theftMarkers">
            <gmap-marker
              :key="index"
              :clickable="m.clickable"
              :icon="getIcon(m.type)"
              :position="m.position"
              :z-index="m.zIndex"
              @click="onMarkerClick(index)"
            >
            </gmap-marker>

            <!-- zone pour THEFT_LOCATION -->
            <GmapCircle
              v-if="index === currentlySelectedAnnonceIndex"
              :key="index+'theftZone'"
              :center="m.position"
              :options="{fillColor:'#E74A49',fillOpacity:0.3, strokeOpacity:0, clickable: false}"
              :radius="1000"
              :visible="true"
            ></GmapCircle>
          </template>
        </GmapCluster>
        <!-- endregion -->
        <!-- region police markers-->
        <template v-for="(m, index) in policeMarkers">
          <gmap-marker
            :key="'police-m-'+ index"
            :clickable="m.clickable"
            :icon="getIcon(m.type)"
            :position="m.position"
            :z-index="m.zIndex"
            @click="openMarker(index)"
          >
            <gmap-info-window
              :closeclick="true"
              :opened="openedMarkerID === policeStations[index].id"
              :options="gmapInfoOptions">
              <div class="b122-gmap-info-window">
                <div class="b122-gmap-info-window-title pb-2">
                  {{ policeStations[index].tostring }}
                </div>
                <div class="pb-1">
                  {{ policeStations[index].address }}
                </div>
                <div class="pb-3">
                  {{ policeStations[index].department.tostring2 }}
                </div>
                <div class="pb-1">
                  {{ policeStations[index].phoneNumber }}
                </div>
              </div>
            </gmap-info-window>

          </gmap-marker>
        </template>
        <!-- endregion -->

      </gmap-map>

    <!--  region display list button on big screen   -->
    <div
      id="display-list-btn-container"
    >
      <div
        class="display-list-btn bold-text cursor-pointer"
        v-on:click="$emit('hideMap')"
      >
        {{ $t('annonce.map.display.search') }}
        <i class="ph-custom ph-list ml-2"></i>
      </div>
    </div>

    <!--  endregion    -->
    <!--  region action buttons    -->
    <div
      class="map-action-button cursor-pointer"
      v-on:click="centerOnUser"
    >
      <i class="ph-crosshair"></i>
    </div>
    <div
      class="map-action-button cursor-pointer"
      v-on:click="onSearchFromCenterOfMap"
    >
      <i class="ph-binoculars"></i>
    </div>
    <!--  endregion    -->
    <!-- region Annonce card/list -->
    <div
      v-if="currentlySelectedAnnonceIndex !== null"
      class="annonce-card-container"
    >
      <div id="big-screen-annonce-list">
        <annonce-card-image-left
          :key="$props.annonces[currentlySelectedAnnonceIndex].serverId"
          :annonce="$props.annonces[currentlySelectedAnnonceIndex]"
          class="cursor-pointer annonce-card"
        />
        <div class="d-flex flex-row">
          <div
            v-if="currentlySelectedAnnonceIndex !== 0"
            class="annonce-list-navigation-button cursor-pointer"
            v-on:click="onPreviousAnnonceClicked"
          >
            <i class="ph-caret-left"></i>
          </div>
          <div
            v-if="currentlySelectedAnnonceIndex !== ($props.annonces.length - 1)"
            class="annonce-list-navigation-button cursor-pointer"
            v-on:click="onNextAnnonceClicked"
          >
            <i class="ph-caret-right"></i>
          </div>
        </div>
      </div>

      <div id="small-screen-annonce-list">
        <div
          class="display-list-btn bold-text cursor-pointer"
          v-on:click="$emit('hideMap')"
        >
          <i class="ph-custom ph-list mr-2"></i>
          {{ $t('annonce.map.display.search.short') }}
        </div>

        <b-carousel
          id="map-annonces-carousel"
          ref="annonces-carousel"
          v-model="currentlySelectedAnnonceIndex"
          :interval="0"
          @sliding-start="onCarouselSliding"
          no-wrap
        >
          <b-carousel-slide
            v-for="(annonce, index) in $props.annonces"
            :key="annonce.serverId"
          >
            <template #default>
              <annonce-card-image-left
                :annonce="annonce"
                class="cursor-pointer annonce-card"
              />
            </template>
          </b-carousel-slide>
        </b-carousel>
      </div>
    </div>
    <!-- endregion -->
  </div>
</template>


<script>

import api from '../../services/api'
import AnnonceCardImageLeft from "../../components/annonce/AnnonceCardImageLeft";

export default {
  name: 'AnnoncesMap',

  components: {
    AnnonceCardImageLeft
  },

  emits : [
    'hideMap',
    'searchFromCenterOfMap'
  ],

  props:{
    user: Object,
    annonces: Array,
  },

  data() {
    return {
      desiredCenter:{
        lat: 43.5937209,
        lng: 1.4480173,
      },
      desiredZoom: 14,
      realCenter:{},
      realZoom:14,
      realBounds:{},

      gmapOptions: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
      },

      theftMarkers:[],
      policeMarkers:[],
      iconMapping: {
        THEFT_LOCATION: require(`@/assets/images/b122/ic-vol.png`),
        POLICE_STATION: require(`@/assets/images/b122/ic-police.png`),
      },

      currentlySelectedAnnonceIndex: 0,
      clusterStyles: [
        { textColor: "white", textSize: 20, height: 50, width: 50, url: this.getFileImageUrl('cluster_gmap_image_theft.png') },
      ],
      clusterCalculator: function(markers, numStyles) {
        var count = markers.length
        var selectedStyleNumero = Math.floor(count/10) + 1

        return {
          text: count,
          index: Math.min(selectedStyleNumero, numStyles)
        }
      },

      //Police
      policeStations:[],
      openedMarkerID: null,
      markerPoliceStation: {
        url: require(`@/assets/images/b122/ic-police.png`),
        //anchor permet de centrer l'icone sur le point exact lat/lng - on prend pas exactement 30/2 = 15 car l'image utilisée n'est pas centrée (il y a une ombre)(sur une image de 120*120px le centre est à 56*56px)
        size: {width: 30, height: 30, f: 'px', b: 'px'},
        anchor: {x: 14, y: 14},
        scaledSize: {width: 30, height: 30, f: 'px', b: 'px'},
      },
      gmapInfoOptions: {
        pixelOffset: {
          width: 0,
          height: -5
        }
      },

    }
  },

  watch:{
    $props: {
      handler() {
        this.handleTheftMarkers()
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    this.handleTheftMarkers()
    this.fetchPoliceStations()
  },

  methods: {
    //region map movements
    centerOnUser(){
      if(this.$props.user
        && this.$props.user.lat
        && this.$props.user.lng
      ){
        this.currentlySelectedAnnonceIndex = null
        //Pour forcer le changement
        this.desiredCenter = {
          lat: 0,
          lng: 0,
        }
        this.$nextTick(() => {
          this.desiredCenter = {
            lat: this.$props.user.lat,
            lng: this.$props.user.lng,
          }
        })
      }
    },
    onCenterChanged(center){
      this.realCenter = {
        lat: center.lat(),
        lng: center.lng()
      }
    },
    onZoomChanged(zoom){
      this.realZoom = zoom
    },
    onBoundsChanged(bounds){
      if(bounds && bounds.Wh && bounds.Gh){
        this.realBounds = {
          neLat: bounds.Wh.hi,
          neLng: bounds.Gh.hi,
          swLat: bounds.Wh.lo,
          swLng: bounds.Gh.lo,
        }
        this.fetchPoliceStations()
      }
    },
    onMapDrag(){
      this.currentlySelectedAnnonceIndex = null
    },
    onPreviousAnnonceClicked(){
      if(this.currentlySelectedAnnonceIndex > 0){
        this.currentlySelectedAnnonceIndex -= 1
        this.onAnnonceSelectionChange()
      }
    },
    onNextAnnonceClicked(){
      if(this.currentlySelectedAnnonceIndex < (this.annonces.length - 1)){
        this.currentlySelectedAnnonceIndex += 1
        this.onAnnonceSelectionChange()
      }
    },
    onAnnonceSelectionChange(){
      this.desiredCenter = {
        lat: this.annonces[this.currentlySelectedAnnonceIndex].vehicle.theftPosition.latitude,
        lng: this.annonces[this.currentlySelectedAnnonceIndex].vehicle.theftPosition.longitude,
      }
      this.desiredZoom = 15
    },
    onCarouselSliding(index){
      this.currentlySelectedAnnonceIndex = index
      this.onAnnonceSelectionChange()
    },
    //endregion

    onSearchFromCenterOfMap(){
      this.$emit('searchFromCenterOfMap', this.realCenter)
    },

    //region fetch police
    fetchPoliceStations(){
      if(this.realBounds.neLat && this.realZoom > 15){
        api({
          method: 'GET',
          url: `/policeStation/getAllPoliceStationInsideBounds?neLat=${this.realBounds.neLat}&neLng=${this.realBounds.neLng}&swLat=${this.realBounds.swLat}&swLng=${this.realBounds.swLng}`,
        })
          .then((response) => {
            this.policeStations = response.data
            this.$nextTick(()=>{
              this.handlePoliceMarkers()
            })
          })
          .catch(() => {
            console.log("error fetching police stations")
          })
      }else{
        this.policeStations = []
        this.policeMarkers = []
      }
    },

    //endregion
    //region markers
    handleTheftMarkers(){
      if(this.annonces){
        this.theftMarkers = []
        this.annonces.forEach((annonce) => {
          if(annonce.vehicle.theftPosition){
            var item = annonce.vehicle.theftPosition
            const theftPosition = {
              clickable: true,
              position: {
                lat: item.latitude,
                lng: item.longitude
              },
              type: item.type.name,
              id: item.id,
              zIndex: 10
            }
            this.theftMarkers.push(theftPosition)
          }
        })
        if(this.theftMarkers.length > 0){
          this.$nextTick(() => {
            this.desiredCenter = this.theftMarkers[0].position
          })
        }
      }
    },
    handlePoliceMarkers(){
      if(this.policeStations){
        this.policeMarkers = []
        this.policeStations.forEach((ps) => {
          const policeStation = {
            clickable: true,
            position: {
              lat: ps.latitude,
              lng: ps.longitude
            },
            type: "POLICE_STATION",
            id: ps.id,
            zIndex: 9
          }
          this.policeMarkers.push(policeStation)
        })
      }
    },
    getIcon(name) {
      const iconUrl = this.iconMapping[name];
      //anchor permet de centrer l'icone sur le point exact lat/lng - on prend pas exactement 30/2 = 15 car l'image utilisée n'est pas centrée (il y a une ombre)(sur une image de 120*120px le centre est à 56*56px)
      return iconUrl ? {
        url: iconUrl,
        size: {width: 30, height: 30, f: 'px', b: 'px'},
        anchor: {x: 14, y: 14},
        scaledSize: {width: 30, height: 30, f: 'px', b: 'px'}
      } : null;
    },
    openMarker(index) {
      this.openedMarkerID = this.policeStations[index].id
    },
    getFileImageUrl(fileName) {
      return fileName ? process.env.SERVER_URL + '/assets/' + fileName : null
    },
    onMarkerClick(index){
      this.currentlySelectedAnnonceIndex = index
      this.onAnnonceSelectionChange()
    }
    //endregion
  }

}

</script>

<style scoped>

.b122-gmap{
  height: 100%;
}

#display-list-btn-container {
  z-index: 3;
  position: fixed;
  bottom: 30px;
  right: 60px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.display-list-btn {
  padding: 10px;
  border-radius: 40px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: var(--main-yellow-medium);
  color: var(--main-black-light);
}
.display-list-btn:hover {
  background-color: var(--main-yellow-dark);
}

.map-action-button{
  z-index: 3;
  display: flex;
  width: 50px;
  height: 50px;
  position: absolute;
  top: 20px;
  right: 10px;
  padding: 10px;
  border-radius: 40px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.3);
  background-color: var(--main-black-darker);
  color: var(--main-yellow-medium);
  font-size: 30px;
}
.map-action-button:nth-of-type(2n){
  top: 80px;
}

.annonce-card-container{
  position: fixed;
  bottom: 10px;
  left: 20px;
}
#big-screen-annonce-list{
  display: flex;
  flex-direction: row;
  align-items: end;
}
#small-screen-annonce-list{
  display: none;
}

.annonce-card{
  width: 400px;
}
.annonce-list-navigation-button{
  width: 50px;
  height: 50px;
  margin-left: 10px;
  margin-top: 10px;
  display: flex;
  padding: 10px;
  border-radius: 40px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.3);
  background-color: var(--main-black-darker);
  color: var(--main-yellow-medium);
  font-size: 30px;
}


@media (max-width: 767px) {
  #display-list-btn-container {
    display: none;
  }
  #big-screen-annonce-list {
    display: none;
  }
  .annonce-card-container {
    left: 0;
    right: 0;
  }
  #small-screen-annonce-list {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #map-annonces-carousel{
    width: 100%;
    padding: 0 10px;
  }
}

@media (max-width: 500px) {
  .annonce-card{
    width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/search/AnnoncesMap.vue